import { px2rem } from '../utils/helpers/style.js';

var sliderThemeWeb = {
  color: 'primary',
  disabled: 'border.disabled',
  height: px2rem(24),
  label: {
    color: 'text.secondary'
  },
  valueIndicator: {
    background: 'text',
    color: 'background'
  },
  rail: {
    inactive: 'border.inactive',
    height: px2rem(4)
  },
  circle: {
    diameter: 24,
    focusHighlightColor: 'background'
  }
};
var sliderThemeNative = {
  color: 'primary',
  disabled: 'border.disabled',
  height: 4,
  label: {
    color: 'text.secondary'
  },
  valueIndicator: {
    background: 'text',
    color: 'background',
    offset: 56,
    triangleWidth: 8
  },
  rail: {
    inactive: 'border.inactive',
    targetableHeight: 44
  },
  circle: {
    diameter: 24
  }
};

export { sliderThemeNative, sliderThemeWeb };
